import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetBooleanState = atomFamily({
  key: "myTimesheetBooleanState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetBooleanState;
